/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMemoryStoresUpdate } from "../../funcs/llmMemoryStoresUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateMemoryStoreRequest$inboundSchema,
};

export const tool$llmMemoryStoresUpdate: ToolDefinition<typeof args> = {
  name: "llm-memory-stores-update",
  description: `Update memory store`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMemoryStoresUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
